export default "__VITE_ASSET__1e4fdf26__"